import { useQuery } from '@tanstack/react-query';
import AttToken from '../helpers/attToken';
import Files from '../service/Files';

const donwloadService = new Files();

export default function useAssinaturaQuery(url: string | null | undefined) {
  return useQuery({
    queryKey: ['GET_ASSINATURA', url],
    enabled: !!url, // só executa se tiver URL
    queryFn: async () => {
      const token = await AttToken();
      if (!token) throw new Error('Token inválido');

      const response = await donwloadService.downloadFiles(token, 'web', '-', [url!]);

      if (response && response.urls.length > 0) {
        const blob = await fetch(response.urls[0]).then(res => res.blob());
        const fileUrl = URL.createObjectURL(blob);
        return fileUrl;
      } else {
        throw new Error('URL de assinatura não encontrada');
      }
    },
    staleTime: 1000 * 60 * 60, // 1 hora (evita refetch constante)
    // cacheTime: 1000 * 60 * 60, // 1 hora
    retry: 1,
  });
}
